import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const BUYERS = ['María G.', 'Carolina R.', 'Ana P.', 'Lucía M.', 'Valentina S.', 'Gabriela T.', 'Sofía L.', 'Isabella D.', 'Camila H.', 'Paula V.', 'Andrea F.', 'Daniela C.', 'Laura B.', 'Natalia O.', 'Fernanda J.'];
const CITIES = ['Ciudad de México', 'Bogotá', 'Buenos Aires', 'Lima', 'Santiago', 'Madrid', 'Medellín', 'Guadalajara', 'Quito', 'Montevideo'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getTimeAgo(): string {
  const mins = Math.floor(Math.random() * 45) + 2;
  return `hace ${mins} min`;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    // Show first popup after 8 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 8000);
    return () => clearTimeout(initialTimeout);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Hide after 5 seconds, then show next one after 15-25 seconds
    const hideTimeout = setTimeout(() => {
      setVisible(false);
      const nextTimeout = setTimeout(() => {
        showNotification();
      }, Math.random() * 10000 + 15000);
      // Store cleanup for next timeout
      return () => clearTimeout(nextTimeout);
    }, 5000);
    return () => clearTimeout(hideTimeout);
  }, [visible]);
  function showNotification() {
    setBuyer({
      name: getRandomItem(BUYERS),
      city: getRandomItem(CITIES),
      time: getTimeAgo()
    });
    setVisible(true);
  }
  return <AnimatePresence data-id="element-196">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 80,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 80
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 max-w-sm" data-id="element-197">
          <div className="flex items-center gap-3 bg-navy-medium border border-cream-muted/15 rounded-lg p-3 shadow-2xl shadow-black/40" data-id="element-198">
            {/* Product image */}
            <img src="https://cdn.magicpatterns.com/uploads/9DjJftWD2DGXMXiZKAx1zc/Untitled_design.png" alt="Método de 21 Noches" className="w-14 h-14 rounded-md object-cover flex-shrink-0" data-id="element-199" />

            {/* Info */}
            <div className="flex-1 min-w-0" data-id="element-200">
              <p className="text-cream text-sm font-semibold truncate" data-id="element-201">
                {buyer.name}
              </p>
              <p className="text-cream-muted text-xs" data-id="element-202">
                compró{' '}
                <span className="text-amber font-medium" data-id="element-203">
                  Método de 21 Noches
                </span>
              </p>
              <div className="flex items-center gap-2 mt-1" data-id="element-204">
                <span className="text-amber font-bold text-sm" data-id="element-205">$17 USD</span>
                <span className="text-cream-muted/60 text-[10px]" data-id="element-206">•</span>
                <span className="text-cream-muted/60 text-[10px]" data-id="element-207">
                  {buyer.city}
                </span>
                <span className="text-cream-muted/60 text-[10px]" data-id="element-208">•</span>
                <span className="text-cream-muted/60 text-[10px]" data-id="element-209">
                  {buyer.time}
                </span>
              </div>
            </div>

            {/* Close button */}
            <button onClick={() => setVisible(false)} className="text-cream-muted/40 hover:text-cream text-lg leading-none flex-shrink-0 p-1" aria-label="Cerrar notificación" data-id="element-210">
              ×
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}